
        var result = require("!!../../../../node_modules/css-loader/index.js!./curecredit-treatment-search.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/curecredit-treatment-search.component.css
// module id = 2352
// module chunks = 1